import { CentralApp } from './CentralApp';
import { registerReactWebComponent } from '@/core/utils/webComponent';

export const registerCentralComponent = () => {
  registerReactWebComponent('content-central-counter', CentralApp, () => ({}));
};
